import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/BrandLeaderBoardSagas";

const FilterByView = () => {
  const dispatch = useDispatch();
  const { viewOptions, selectedViewOption } = useSelector((state) => state.BrandLeaderBoard);
  return (
    <MultiSelectDropdown
      filterType="Custom Range"
      options={viewOptions}
      selectedFilters={selectedViewOption}
      includeFilter={false}
      maxSelect={1}
      enableMax
      enableDefaultSelected
      haveOnSelectChange={false}
      updateLocations={(data) => dispatch(actionCreators.updateView(data))}
    />
  );
};

export default FilterByView;
